module.exports = __webpack_public_path__ + "img/13.ae326da1.svg";